<template>
  <div class="signature-pad">
    <div class="signature-header">
      <h4>{{ title }}</h4>
      <div class="signature-actions">
        <el-button size="small" @click="clear" :disabled="!hasSignature">
          <i class="el-icon-delete"></i> Clear
        </el-button>
      </div>
    </div>
    
    <div class="canvas-container" ref="container">
      <canvas
        ref="canvas"
        style="display: block; touch-action: none; cursor: crosshair; width: 100%; height: 100%;"
        @mousedown="startDrawing"
        @mousemove="draw"
        @mouseup="stopDrawing"
        @mouseleave="stopDrawing"
        @touchstart="startDrawing"
        @touchmove="draw"
        @touchend="stopDrawing"
      ></canvas>
    </div>

    <div class="signature-status">
      <span v-if="hasSignature" style="color: #67C23A">
        <i class="el-icon-check"></i> Signed
      </span>
      <span v-else style="color: #909399">
        <i class="el-icon-edit"></i> Please sign your name here
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignaturePad',
  props: {
    title: { type: String, default: '电子签名' },
    height: { type: Number, default: 200 },
    value: { type: String, default: '' }
  },
  data() {
    return {
      isDrawing: false,
      ctx: null,
      hasSignature: false
    };
  },
  mounted() {
    // 必须等待 DOM 完成渲染后才能获取容器宽度
    this.$nextTick(() => {
      this.initCanvas();
      window.addEventListener('resize', this.initCanvas);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initCanvas);
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.canvas;
      const container = this.$refs.container;
      
      // 获取父容器的实际宽度，并动态设置 canvas 的逻辑分辨率
      const rect = container.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = this.height;
      
      this.ctx = canvas.getContext('2d');
      this.ctx.strokeStyle = '#000000';
      this.ctx.lineWidth = 3;
      this.ctx.lineCap = 'round';
      this.ctx.lineJoin = 'round';
    },
    getPos(e) {
      const canvas = this.$refs.canvas;
      const rect = canvas.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      return { x: clientX - rect.left, y: clientY - rect.top };
    },
    startDrawing(e) {
      if (e.cancelable) e.preventDefault();
      this.isDrawing = true;
      const pos = this.getPos(e);
      this.ctx.beginPath();
      this.ctx.moveTo(pos.x, pos.y);
    },
    draw(e) {
      if (!this.isDrawing) return;
      if (e.cancelable) e.preventDefault();
      
      const pos = this.getPos(e);
      this.ctx.lineTo(pos.x, pos.y);
      this.ctx.stroke();
      this.hasSignature = true;
    },
    stopDrawing() {
      if (this.isDrawing) {
        this.isDrawing = false;
        this.saveSignature();
      }
    },
    clear() {
      // 重新设置 canvas.width 可以重置画布并清除内容
      this.initCanvas();
      this.hasSignature = false;
      this.$emit('input', '');
    },
    saveSignature() {
      const dataURL = this.$refs.canvas.toDataURL('image/png');
      this.$emit('input', dataURL);
    }
  }
};
</script>

<style scoped>
.signature-pad { border: 1px solid #DCDFE6; padding: 15px; background: #fff; }
.signature-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
.canvas-container { 
  width: 100%; /* 自动铺满父元素 */
  border: 2px dashed #DCDFE6; 
  background: #f5f7fa; 
  overflow: hidden;
}
.signature-status { margin-top: 8px; font-size: 12px; text-align: center; }
</style>